"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldNullException = void 0;
class FieldNullException extends Error {
    constructor(fieldName) {
        super(`the field "${fieldName}" can not be null or undefined`);
    }
}
exports.FieldNullException = FieldNullException;
